import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AdminPageTitle from '../components/AdminPageTitle';
import { login } from '../services/auth';
import { setCredentials } from '../store/slices/authSlice';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    // Store password temporarily for login (never stored in Redux)
    const password = formData.password;
    
    // Clear password from state immediately for security
    setFormData(prev => ({ ...prev, password: '' }));

    try {
      const response = await login(formData.email, password);
      
      // Check if user is admin
      if (response.user && response.user.role === 'admin') {
        // Save to Redux store (password is NOT included)
        dispatch(setCredentials({
          user: response.user,
          token: response.token,
        }));
        
        navigate('/admin/dashboard');
      } else {
        setError('Access denied. Admin privileges required.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 
        err.response?.data?.email?.[0] || 
        'Login failed. Please check your credentials.'
      );
    } finally {
      setLoading(false);
      // Ensure password is cleared from form
      setFormData(prev => ({ ...prev, password: '' }));
    }
  };

  return (
    <div className="login-page">
      <AdminPageTitle title="Login" />
      <div className="login-container">
        <div className="login-header">
          <h1>FM Ultratech Farms</h1>
          <h2>Admin Login</h2>
          <p>Sign in to access the admin panel</p>
        </div>

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="admin@fmultratech.com"
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          <button 
            type="submit" 
            className="btn-login"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p className="help-text">
            Forgot your password? Contact system administrator.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
